var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"100px"}},[_c('div',{staticClass:"container"},[_c('h4',[_vm._v("Project No.: "+_vm._s(this.$route.query.projectNo))]),_c('Workpackage_Header',{attrs:{"namespace":_vm.namespace}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }